import { render, staticRenderFns } from "./ESocialSituationInfoModal.vue?vue&type=template&id=2d348916&"
import script from "./ESocialSituationInfoModal.vue?vue&type=script&lang=js&"
export * from "./ESocialSituationInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports